import { styled } from '@defa/defa-component-library';

export const Root = styled.div`
    min-height: calc(100vh - 64px); /* header */
    display: flex;
    align-items: flex-start;
    padding: 48px; /* match site padding */
`;
